import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL ZONE BY LOCATION ID
export const getAllZone = createAsyncThunk('zone/getAllZone', async (payload, thunkAPI) => {
  const { locationId, categoryId } = payload;

  let mainUrl = `/zone`;

  if (locationId) {
    mainUrl += `?location_id=${locationId}`;
  }

  if (categoryId) {
    mainUrl += `&category_id=${categoryId}`;
  }

  try {
    const response = await axiosInstance.get(mainUrl);

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

// GET ALL ZONE
export const getAllZoneAdmin = createAsyncThunk('zone/getAllZoneAdmin', async (page, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/zone?limit=10&page=${page}`);

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

// GET ALL ZONE DETAIL BY ID
export const getZoneDetailById = createAsyncThunk('zone/getZoneDetailById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/zone/${id}`);

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

// GET ALL LIST ZONE
export const getListZone = createAsyncThunk('zone/getListZone', async (payload, thunkAPI) => {
  const { page, name, all, locationId, categoryId } = payload;

  let mainUrl = `/list-zone?limit=10`;

  if (page) {
    mainUrl += `&page=${page}`;
  }

  if (name) {
    mainUrl += `&name=${name}`;
  }

  if (all) {
    mainUrl += `&all=${all}`;
  }

  if (locationId) {
    mainUrl += `&location_id=${locationId}`;
  }

  if (categoryId) {
    mainUrl += `&category_id=${categoryId}`;
  }

  try {
    const response = await axiosInstance.get(mainUrl);

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue('Failed to get zone list');
  }
});

// ADD NEW ZONE
export const createNewZone = createAsyncThunk('zone/createNewZone', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/zone`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});

// EDIT ZONE BY ID
export const editZoneById = createAsyncThunk('zone/editZoneById', async ({ payload, id }, thunkAPI) => {
  try {
    const response = await axiosInstance.put(`/zone/${id}`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});

// DELETE ZONE BY ID
export const deleteZoneById = createAsyncThunk('zone/deleteZoneById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/zone/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});

// ADD NEW LIST ZONE
export const addListZones = createAsyncThunk('zone/addListZones', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/list-zone`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});

// EDIT ZONE BY ID
export const editListZoneById = createAsyncThunk('zone/editListZoneById', async ({ payload, id }, thunkAPI) => {
  try {
    const response = await axiosInstance.put(`/list-zone/${id}`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});

// DELETE LIST ZONE BY ID
export const deleteListZoneById = createAsyncThunk('zone/deleteListZoneById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/list-zone/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});

// UPLOAD ZONE IMAGE
export const uploadZoneImage = createAsyncThunk('zone/uploadZoneImage', async (image, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `/zone-image/upload`,
      { file: image },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.slug);
  }
});

// CREATE ZONE IMAGE
export const createZoneImage = createAsyncThunk('zone/createZoneImage', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/zone-image`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create zone image');
  }
});

// GET ALL ZONE REGION TYPE
export const getAllZoneType = createAsyncThunk('zone/getAllZoneType', async ({ page, limit = 10 }, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/region-types?limit=${limit}&page=${page}`);

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

// GET ZONE TYPE DETAIL BY ID
export const getZoneTypeDetailById = createAsyncThunk('zone/getZoneTypeDetailById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/region-types/${id}`);

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

// ADD NEW ZONE TYPE
export const addNewZoneType = createAsyncThunk('zone/addNewZoneType', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/region-types`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});

// EDIT ZONE TYPE BY ID
export const editZoneTypeById = createAsyncThunk('zone/editZoneTypeById', async ({ payload, id }, thunkAPI) => {
  try {
    const response = await axiosInstance.put(`/region-types/${id}`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});

// DELETE ZONE TYPE BY ID
export const deleteZoneTypeById = createAsyncThunk('zone/deleteZoneTypeById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/region-types/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('Failed to create new zone');
  }
});
